module.exports = function getResource(label, vars = []) {
    const resources = {
        chooseStore: 'Choose a Store',
        setYourLocation: 'Set Your Location',
        pickup: 'Pickup',
        reset: 'Reset'
    };

    return resources[label];
};
